module.exports = ".buttons_wrapper > * {\n  cursor: pointer; }\n"